import { render, staticRenderFns } from "./NpsModal.vue?vue&type=template&id=74652cdc&scoped=true"
import script from "./NpsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NpsModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NpsModal.vue?vue&type=style&index=0&id=74652cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74652cdc",
  null
  
)

export default component.exports